import { render, staticRenderFns } from "./DealerCarsSlider.vue?vue&type=template&id=2756bb85"
import script from "./DealerCarsSlider.vue?vue&type=script&lang=js"
export * from "./DealerCarsSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports